import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { getObserver } from '../../components/ElementInViewport/utils';
import { FiltersSearchButton } from '../../components/FiltersSearchButton';
import { selectMortgageFilterDownPayment } from '../../selectors/mortgage/selectMortgageFilterDownPayment';
import { selectMortgageFilterRealtyPrice } from '../../selectors/mortgage/selectMortgageFilterRealtyPrice';
import { createMortgageMainUrl } from '../../utils/mortgage/createMortgageMainUrl';
import { trackMortgageButtonClick, trackMortgageButtonShow } from './tracking';

const text = 'Получить предложения банков';

export const FiltersMortgageButtonsContainer = () => {
  const realtyPrice = useSelector(selectMortgageFilterRealtyPrice);
  const downPayment = useSelector(selectMortgageFilterDownPayment);
  const buttonRef = useRef<HTMLElement>(null);
  const hasTrackedShow = useRef(false);

  useEffect(() => {
    const el = buttonRef.current;
    if (!el) {
      return;
    }

    const handleVisible = () => {
      if (hasTrackedShow.current) {
        return;
      }
      hasTrackedShow.current = true;
      trackMortgageButtonShow();
    };

    return getObserver()({
      target: el,
      threshold: 0.5,
      onVisible: handleVisible,
    });
  }, []);

  return (
    <FiltersSearchButton
      ref={buttonRef}
      onClick={trackMortgageButtonClick}
      dataMark="FiltersMortgageRightButton"
      text={text}
      title={text}
      href={createMortgageMainUrl(realtyPrice, downPayment)}
    />
  );
};
